import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

import { FIELD_KEYS } from '_constants/forms';
import { theme } from '_constants/theme';
import { getFieldProps } from '_helpers/forms/fields';

import Button from 'components/atomic/Button';
import Spinner from 'components/atomic/Spinner';
import BaseField from 'components/atomic/fields/BaseField';
import Text from 'components/atomic/layouts/Text';

const StyledForm = styled(Form)`
  width: 100%;
`;

const StyledMessageContainer = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.regular}px;
`;

const SendTaskResponseForm = ({ loading, error, submitDisabled, defaultValues, onCancel, onSubmit }) => {
  const {
    control,
    formState: { isSubmitted, isSubmitSuccessful, submitCount },
    handleSubmit,
  } = useForm({
    defaultValues,
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    if (isSubmitted && !isSubmitSuccessful && submitCount) {
      onSubmit();
    }
  }, [isSubmitted, isSubmitSuccessful, submitCount, onSubmit]);

  return (
    <StyledForm noValidate onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col xs={12}>
          <BaseField {...getFieldProps(FIELD_KEYS.response)} control={control} bottomSpace={theme.spaces.regular} />
        </Col>
        <Col xs={6}>
          <Button outlined onClick={onCancel}>
            Cancel
          </Button>
        </Col>
        <Col xs={6}>
          <Button type="submit" disabled={submitDisabled} color={theme.colors.indigo.primary}>
            Submit
          </Button>
        </Col>
      </Row>

      {loading && (
        <Text size={theme.fontSizes.small} color={theme.colors.gray.secondary} topSpace={theme.spaces.regular}>
          <StyledMessageContainer>
            <Spinner />
            <div>Sending...</div>
          </StyledMessageContainer>
        </Text>
      )}

      {error && (
        <Text size={theme.fontSizes.small} color={theme.colors.red.primary} topSpace={theme.spaces.regular}>
          {error?.message}
        </Text>
      )}
    </StyledForm>
  );
};

SendTaskResponseForm.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.object,
  submitDisabled: PropTypes.bool,
  defaultValues: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default SendTaskResponseForm;
